export default __webpack_public_path__ + "96bb6426558b9bde81746f9a868618a3.webp";